<template>
    <div>
        <div class="row">
            <div class="col-lg-12">
                <div class="form-group form-group-1">
                    <label for="" class="form-label">Notes</label>
                    <textarea
                        v-model="reactivationNote"
                        type="text"
                        class="form-control height-2"></textarea>
                </div>
            </div>
            <div class="col-12">
                <div class="form-group form-group-1">
                    <div class="btns-wrap" style="justify-content: flex-end;">
                        <button class="btn btn--secondary w-100 w-sm-auto" @click="updateStatus" >Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import DeactivationServices from "../services/DeactivationServices";

export default {
    props: {
        statusInfo: {
            type: Object
        }
    },

    name: 'ReactivationStatus',
    data() {
        return {
           reactivationNote: this.statusInfo.note
        }
    },
    methods: {
        async updateStatus() {
            this.$showLoadingMessage()
            try {
                await DeactivationServices.updateReactivationStatus(this.statusInfo.id, this.reactivationNote)
                this.$showSuccessMessage('Your information has been saved')
            } catch (e) {
                console.error(e)
                this.$showErrorMessage('Your information was not saved. Please try again')
            }
        }
    }

}

</script>


<style scoped>

</style>
